$(document).ready(function() {
    var MicroModal = require('app_custom_mufe/lib/micromdal-ie');
    var acaMainIngredientsElmt = $('.aca_main_moreinformation').clone();

    $('.aca_main_moreinformation').remove();
    $('.long-description-text .contact-us').after(acaMainIngredientsElmt);

    $("button[data-micromodal-trigger='certifyingInformation']").on('click', function () {
        MicroModal.show('certifyingInformation');
    });
    $("button[data-micromodal-trigger='additionalInformation']").click(function () {
        MicroModal.show('additionalInformation');
    });

    for (let i = 1; i <= PropertiesPreferences.ACADEMY_SESSION_EXTRA_INFORMTION; i++) {
        $("button[data-micromodal-trigger='extraInformation-" + i + "']").on('click', function () {
            MicroModal.show('extraInformation-'+ i +'');
        });
    }
});